import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { MSS_FORMLY_IMPORTS } from '@shared/components/formly/formly-standalone-imports';

@Component({
  templateUrl: 'repeating.component.html',
  imports: [...MSS_FORMLY_IMPORTS],
})
export class RepeatingFieldTypeComponent extends FieldArrayType {}
